import { browserHistory } from 'react-router';
import {
  all,
  call,
  fork,
  put,
  select,
  takeEvery,
  takeLatest,
} from 'redux-saga/effects';
import {
  DOCTYPE_SHORTCUT,
  DOCTYPE_SHORTCUT_GROUP,
} from '@krispsystems/constants';

import * as api from '../../services/shortcut/api_shortcut';
import * as apiCommon from '../../services/apiCommon';
import * as common from '../sagasCommon';

export default function* (app) {
  try {
    yield all([
      fork(deleteShortcutGroupSaga, app),
      fork(deleteShortcutSaga, app),
      fork(fetchListShortcutGroupSaga, app),
      fork(fetchListShortcutSaga, app),
      fork(fetchShortcutGroupSaga, app),
      fork(fetchShortcutSaga, app),
      fork(saveShortcutGroupSaga, app),
      fork(saveShortcutSaga, app),
    ]);
  } catch (e) {
    console.error('@sagas_shortcut: ', e.message || e.stack);
    throw e;
  }
}

function* fetchListShortcutGroupSaga(app) {
  yield takeLatest(
    'FETCH_LIST_SHORTCUT_GROUP',
    callFetchListShortcutGroup,
    app
  );
}

function* callFetchListShortcutGroup(app, action) {
  const { filters, silent } = action;
  yield common.showProgressListTable(silent);

  try {
    const dataParams = {
      filters,
      list_type: DOCTYPE_SHORTCUT_GROUP,
    };

    const tableData = yield call(apiCommon.getDocs, app, dataParams);

    yield call(common.doneListTable, {
      rows: tableData.data,
      total_rows: tableData.total,
    });
  } catch (error) {
    yield common.showErrorListTable(error);
  }
}

function* deleteShortcutGroupSaga(app) {
  yield takeEvery('DELETE_SHORTCUT_GROUP', callDeleteShortcutGroup, app);
}

function* callDeleteShortcutGroup(app, action) {
  try {
    const { id } = action;

    if (!id) return;

    yield put({ type: 'DELETE_RECORD_INPROGRESS' });

    const state = yield select();
    const { tenant, user } = state;
    const params = { tenant, user, id };
    yield call(api.deleteShortcutGroup, app, params);

    yield put({
      type: 'DELETE_RECORD_DONE',
      payload: { id, docType: DOCTYPE_SHORTCUT_GROUP },
    });

    browserHistory.push('/admin/shortcut/group');
    yield callFetchListShortcutGroup(app, { silent: true });
  } catch (error) {
    yield put({ type: 'DELETE_RECORD_ERROR', error });
  }
}

function* fetchShortcutGroupSaga(app) {
  yield takeEvery('FETCH_SHORTCUT_GROUP', callFetchShortcutGroup, app);
}

function* callFetchShortcutGroup(app, action) {
  try {
    const { tenant, user } = yield select();
    const { id, silent } = action;

    if (!id) return;

    yield common.showProgressDataById(silent);
    const fetchParams = { tenant, user, id };
    const doc = yield call(api.fetchShortcutGroup, app, fetchParams);
    yield common.doneDataById(doc);
  } catch (error) {
    yield put({ type: 'FETCH_DATA_BY_ID_ERROR', error: error });
  }
}

function* saveShortcutGroupSaga(app) {
  yield takeEvery('SAVE_SHORTCUT_GROUP', callSaveShortcutGroup, app);
}

function* callSaveShortcutGroup(app, action) {
  try {
    yield common.showProgressSaveRecord();
    const { tenant, user } = yield select();

    const result = yield call(api.saveShortcutGroup, app, {
      tenant,
      user,
      data: action.data,
    });

    const id = result && result.id;
    yield callFetchShortcutGroup(app, { id, silent: true });
    yield common.doneSaveRecord(result, 'Shortcut group was saved');
    browserHistory.push(`/admin/shortcut/group/edit/${id}`);
    yield callFetchListShortcutGroup(app, { silent: true });
  } catch (error) {
    yield common.showErrorSaveRecord(error);
  }
}

function* fetchListShortcutSaga(app) {
  yield takeLatest('FETCH_LIST_SHORTCUT', callFetchListShortcut, app);
}

function* callFetchListShortcut(app, action) {
  const { filters, silent } = action;
  yield common.showProgressListTable(silent);

  try {
    const dataParams = {
      filters,
      list_type: DOCTYPE_SHORTCUT,
    };

    const tableData = yield call(apiCommon.getDocs, app, dataParams);
    yield call(common.doneListTable, {
      rows: tableData.data,
      total_rows: tableData.total,
    });
  } catch (error) {
    yield common.showErrorListTable(error);
  }
}

function* deleteShortcutSaga(app) {
  yield takeEvery('DELETE_SHORTCUT', callDeleteShortcut, app);
}

function* callDeleteShortcut(app, action) {
  try {
    const { id } = action;

    if (!id) return;

    yield put({ type: 'DELETE_RECORD_INPROGRESS' });

    const state = yield select();
    const { tenant, user } = state;
    const params = { tenant, user, id };
    yield call(api.deleteShortcut, app, params);

    yield put({
      type: 'DELETE_RECORD_DONE',
      payload: { id, docType: DOCTYPE_SHORTCUT },
    });

    browserHistory.push('/admin/shortcut/definition');
  } catch (error) {
    yield put({ type: 'DELETE_RECORD_ERROR', error });
  }
}

function* fetchShortcutSaga(app) {
  yield takeEvery('FETCH_SHORTCUT', callFetchShortcut, app);
}

function* callFetchShortcut(app, action) {
  try {
    const { tenant, user } = yield select();
    const { id, silent } = action;

    if (!id) return;

    yield common.showProgressDataById(silent);
    const fetchParams = { tenant, user, id };
    const doc = yield call(api.fetchShortcut, app, fetchParams);
    yield common.doneDataById(doc);
  } catch (error) {
    yield put({ type: 'FETCH_DATA_BY_ID_ERROR', error: error });
  }
}

function* saveShortcutSaga(app) {
  yield takeEvery('SAVE_SHORTCUT', callSaveShortcut, app);
}

function* callSaveShortcut(app, action) {
  try {
    yield common.showProgressSaveRecord();
    const { tenant, user } = yield select();

    const result = yield call(api.saveShortcut, app, {
      tenant,
      user,
      data: action.data,
    });

    const id = result && result.id;
    yield callFetchShortcut(app, { id, silent: true });
    yield common.doneSaveRecord(result, 'Shortcut was saved');
    browserHistory.push(`/admin/shortcut/definition/edit/${id}`);
  } catch (error) {
    yield common.showErrorSaveRecord(error);
  }
}
